export { default as HomePage } from "./homePage";
export { default as About } from "./about";
export { default as Phone } from "./Login";
export { default as Reset } from "./ResetPassword";
export { default as Otp } from "./otp";
export { default as Employees } from "./employees";
export { default as Plans } from "./insureplan";
export { default as EnrollmentProcess } from "./processForEnrollment";
export { default as BusinessMemberDetails } from "./memberCompleteDetailsPage";
export { default as Dashboard } from "./dashboard";
export { default as MakePayment } from "./makePayment";
export { default as PaymentSummary } from "./paymentSummary";
export { default as EmployeeRegistrationDashboard } from "./employeeRegistrationDashboard";

export { default as Payment } from "./payment";
export { default as BanksList } from "./banksLists";
export { default as NetBankingDetails } from "./netBankingDetails";
export { default as PaymentSuccessful } from "./paymentSuccessful";
export { default as Profile } from "./profile";
export { default as Receipt } from "./receipt";
export { default as Marketplace } from "./marketPlace";
export { default as MarketPlaceOffers } from "../../pages/MarketPlaceOffers";
export { default as PolicyDocument } from "./policyDoc";
export { default as MembersType } from "./membersType";
export { default as SelectPlanType } from "./selectPlantype";
export { default as SelectPolicyType } from "./selectlpolicytype";
export { default as InsurePlanSummary } from "./insureplanSummary";
export { default as OptionForEmployeeDetails } from "./optionsToAddMembers";
export { default as UploadExcel } from "./uploadexcel";
export { default as CdAccount } from "./cdAccount";
export { default as ViewCdBalance } from "./ViewCd/ViewCdBalance";
export { default as ViewCdTable } from "./ViewCd/ViewCdTable";
export { default as AddDeleteEmployee } from "./addDeleteEmployee";
export { default as EmployeeDetailForm } from "./employeeDetailForm";
export { default as PrePurchasePlanRecommendation } from "./prePurchasePlanRecommendation";
export { default as ThankYou } from "./thankYou";
export { default as GmcPaymentSummary } from "./gmcPaymentSummary";
export { default as EnrolmentHistory } from "../EnrolmentHistory";
export { default as ViewCb } from "./ViewCB";
export { default as BufferTable } from "./ViewCB/BufferTable";
export { default as ViewGradeSetup } from "./ViewGradeSetup";
export { default as ClaimSupport } from "./ClaimSupport";

export { default as GSTno } from "./gstno";
export { default as UploadPanDetails } from "./uploadpan";
export { default as EmployerAddress } from "./employerAddress";
export { default as Renewal } from "./renewal";
export { default as ClaimProcess } from "./claimprocess";
export { default as BhartiTnC } from "./bhartiTnC";
export { default as Referral } from "./referral";
export { default as ShareOnWhatsapp } from "./shareonwhatsapp";
export { default as ReferralFees } from "./referralfees";
export { default as ReferralTermsAndConditions } from "./referralTermsAndConditions";
export { default as SubsPayment } from "./subscriptionPayment";
export { default as OfflineQuotes } from "./insureplanOfflineQuotes";
export { default as SelfpaymentOptions } from "./selfpaymentOptions";
export { default as AutopaymentOptions } from "./autopaymentoptions";
export { default as SubscriptionselfPay } from "./subscriptionselfPay";
export { default as SubscriptionautoPay } from "./subscriptionautoPay";
export { default as AutoBanksList } from "./autobanksLists";
export { default as ECardPreview } from "./GmcDashboard/ECardPreview";
export { default as ECardDownload } from "./GmcDashboard/ECardDownload";
export { default as EndorsementHistory } from "../EndorsementHistory";
export { default as DataCollection } from "./DataCollection";
export { default as MyProfile } from "./MyProfile";
export { default as ResetPasswordInternalPage } from "./MyProfile/ResetPage";
